import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useZone } from "@/contexts/ZoneContext";
import { cn } from "@/lib/utils";
import { ZONES, type ZoneId } from "@shared/zones";
import { MapPin } from "lucide-react";

interface ZoneSelectorProps {
  className?: string;
  compact?: boolean;
  showSuburbs?: boolean;
}

export function ZoneSelector({
  className,
  compact = false,
  showSuburbs = true,
}: ZoneSelectorProps) {
  const { selectedZoneId, selectedZone, setSelectedZoneId, isLoading } =
    useZone();

  if (isLoading) {
    return null;
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {!compact && (
        <Badge variant="outline" className="hidden gap-1.5 sm:inline-flex">
          <MapPin className="h-3.5 w-3.5" />
          Zone
        </Badge>
      )}
      <Select
        value={selectedZoneId}
        onValueChange={(value) => setSelectedZoneId(value as ZoneId)}
      >
        <SelectTrigger
          className={cn(compact ? "h-8 w-[180px]" : "h-9 w-[240px]")}
          data-testid="zone-selector"
        >
          <SelectValue placeholder="Zone 선택" />
        </SelectTrigger>
        <SelectContent>
          {ZONES.map((zone) => (
            <SelectItem key={zone.id} value={zone.id}>
              <div className="flex flex-col">
                <span className="font-medium">{zone.label}</span>
                {showSuburbs && (
                  <span className="text-xs text-muted-foreground">
                    {zone.suburbs.slice(0, 3).join(", ")}
                  </span>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!compact && (
        <span className="hidden text-xs text-muted-foreground md:inline">
          {selectedZone.city}, {selectedZone.state}
        </span>
      )}
    </div>
  );
}

